export default __webpack_public_path__ + "assets/models/9057c0de91907da529f81fc77705663d.glb";